export default __webpack_public_path__ + "static/media/layout2.af5c43c6.svg";